import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { useNavigate } from 'react-router-dom';
import { FiEdit3, FiGitBranch } from 'react-icons/fi';

interface MigrateToForgeButtonProps {
  personaId: string;
  hasEngineeringProfile?: boolean;
  compact?: boolean;
}

export const MigrateToForgeButton: React.FC<MigrateToForgeButtonProps> = ({ 
  personaId, 
  hasEngineeringProfile = false,
  compact = false 
}) => {
  const { darkMode } = useTheme();
  const navigate = useNavigate();
  
  const handleEdit = () => {
    navigate(`/personas/forge?personaId=${personaId}`);
  };
  
  const handleRemix = () => {
    navigate(`/personas/forge`, { state: { remixPersonaId: personaId } });
  };
  
  return (
    <div className={`flex ${compact ? 'gap-1' : 'gap-2'}`}>
      {hasEngineeringProfile && (
        <button
          onClick={handleEdit}
          className={`${compact ? 'text-xs' : ''} ${
            darkMode 
              ? 'text-indigo-400 hover:text-indigo-300' 
              : 'text-indigo-600 hover:text-indigo-500'
          } font-medium flex items-center`}
        >
          <FiEdit3 className={`${compact ? 'h-3 w-3' : 'h-4 w-4'} mr-1`} />
          {compact ? 'Edit' : 'Edit in Forge'}
        </button>
      )}
      
      <button
        onClick={handleRemix}
        className={`${compact ? 'text-xs' : ''} ${
          darkMode 
            ? 'text-rose-400 hover:text-rose-300' 
            : 'text-rose-600 hover:text-rose-500'
        } font-medium flex items-center`}
      >
        <FiGitBranch className={`${compact ? 'h-3 w-3' : 'h-4 w-4'} mr-1`} />
        {hasEngineeringProfile 
          ? (compact ? 'Remix' : 'Remix Persona') 
          : (compact ? 'Migrate' : 'Migrate to Forge')}
      </button>
    </div>
  );
};
